import React from "react";
import { Space, Layout, Divider, Typography, Card } from "antd";
import {
  CheckCircleTwoTone,
  AppstoreAddOutlined,
  CloudServerOutlined,
} from "@ant-design/icons";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function AuthSideContent() {
  return (
    <Content
      style={{
        display: "flex",
        justifyContent: "flex-end",  // ✅ push to the right
        alignItems: "center",        // center vertically
        height: "100%",              // take full height of parent
        padding: "20px 40px",        // add right padding for spacing
      }}
      className="sideContent"
    >
      <Card
        style={{
          borderRadius: 16,
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          padding: "40px 30px",
          textAlign: "center",
          width: "100%",
          maxWidth: 420,
        }}
      >
        <Title level={3} style={{ fontWeight: 600, marginBottom: 20 }}>
          Manage your store with
        </Title>

        <Space
          direction="vertical"
          size="large"
          style={{ width: "100%", textAlign: "left" }}
        >
          <Space align="start">
            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 20 }} />
            <div>
              <Text strong>All-in-one tool</Text>
              <br />
              <Text type="secondary">
                Build, run, and scale your apps end-to-end with ease.
              </Text>
            </div>
          </Space>

          <Space align="start">
            <AppstoreAddOutlined style={{ fontSize: 20, color: "#1677ff" }} />
            <div>
              <Text strong>Easily add &amp; manage services</Text>
              <br />
              <Text type="secondary">
                Add new features or update your services seamlessly.
              </Text>
            </div>
          </Space>

          <Space align="start">
            <CloudServerOutlined style={{ fontSize: 20, color: "#722ed1" }} />
            <div>
              <Text strong>Reliable performance</Text>
              <br />
              <Text type="secondary">
                Scalable cloud infrastructure ensures smooth operations.
              </Text>
            </div>
          </Space>
        </Space>

        <Divider style={{ margin: "30px 0" }} />
        <Text type="secondary" style={{ fontSize: 12 }}>
          © {new Date().getFullYear()} GaspDelivery. All rights reserved.
        </Text>
      </Card>
    </Content>
  );
}
